"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var from_1 = require("rxjs/observable/from");
/**
 * Pipe for transforming report tree element to path.
 */
var ReportElementPathPipe = /** @class */ (function () {
    function ReportElementPathPipe(pathService) {
        this.pathService = pathService;
    }
    ReportElementPathPipe.prototype.transform = function (element, dataSetId) {
        var pathId = null;
        if (element == null) {
            return from_1.from([null]);
        }
        if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
            pathId = element.categoryElementDto.categoryPathHolderId;
        }
        else if (element instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
            pathId = element.measurePathHolderId;
        }
        else if (element instanceof idm_reporting_service_client_js_1.RowCategoryDto) {
            pathId = element.categoryElementDto.categoryPathHolderId;
        }
        if (pathId == null) {
            return from_1.from([null]);
        }
        var getPaths = Observable_1.Observable.fromPromise(this.pathService.getPaths(dataSetId));
        return getPaths.map(function (paths) {
            var categoryPath = paths.categoryPaths.get(pathId);
            var measurePath = paths.measurePaths.get(pathId);
            if (measurePath) {
                return measurePath;
            }
            if (categoryPath) {
                return categoryPath;
            }
            return null;
        });
    };
    ReportElementPathPipe = __decorate([
        core_1.Pipe({
            name: 'reportElementPath',
            pure: true
        }),
        __metadata("design:paramtypes", [idm_dataset_service_client_js_1.PathService])
    ], ReportElementPathPipe);
    return ReportElementPathPipe;
}());
exports.ReportElementPathPipe = ReportElementPathPipe;
//# sourceMappingURL=report-element-path.pipe.js.map